const DASHBOARD_URL = process.env.API_URL + '/aggregateData';
const DASHBOARD_CORPORATE_DATA_URL = process.env.API_URL + '/aggregateData/corporateData';
const DASHBOARD_GROUPS_URL = process.env.API_URL + '/groupData';

const getAggregateData = (context, groupId, startDate, endDate) => {
  return new Promise((resolve, reject) => {
    context.$http.get(DASHBOARD_URL, {params: {groupId: groupId, startDate: startDate, endDate: endDate}})
      .then(response => {
        const aggregateData = response.body;
        resolve(aggregateData);
      }, error => {
        reject(error);
      });
  });
};

const getCorporateData = (context, groupId, startDate, endDate) => {
  return new Promise((resolve, reject) => {
    context.$http.get(DASHBOARD_CORPORATE_DATA_URL, {params: {groupId: groupId, startDate: startDate, endDate: endDate}})
      .then(response => {
        const corporateData = response.body;
        resolve(corporateData);
      }, error => {
        reject(error);
      });
  });
};

const getGroups = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(DASHBOARD_GROUPS_URL, { params: {} })
      .then(response => {
        if (response.body && Array.isArray(response.body)) {
          // Transform response into the correct format
          const formattedGroups = response.body.map(group => ({
            id: group.id,
            label: group.name
          }));

          resolve(formattedGroups);
        } else {
          reject(new Error('Invalid API response format'));
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

export default {
  getAggregateData,
  getGroups,
  getCorporateData
};



// WEBPACK FOOTER //
// ./src/brand/health/api/dashboard/index.js